import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// HOC that provides the same functionality as withRouter from React Router v5
export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  }

  return ComponentWithRouterProp;
}